import { render, staticRenderFns } from "./PendingNotificationsBanner.vue?vue&type=template&id=753a94cd&scoped=true"
import script from "./PendingNotificationsBanner.vue?vue&type=script&lang=js"
export * from "./PendingNotificationsBanner.vue?vue&type=script&lang=js"
import style0 from "./PendingNotificationsBanner.vue?vue&type=style&index=0&id=753a94cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753a94cd",
  null
  
)

export default component.exports